module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/3_9d42973aea7597387c63a80674173ab3.png";